import { createStore } from 'vuex';

export default createStore({
	state: {
		questionsArr: [],
		userAnswers: [],
		currentQuestionIndex: 0,
	},
	mutations: {
		saveNewQuestions(state, payload) {
			state.questionsArr = payload;
		},
		increaseCurrentQuestionIndex(state) {
			state.currentQuestionIndex++;
		},
		saveUserAnswer(state, payload) {
			const { questionIndex, answerIndex } = payload;
			state.userAnswers[questionIndex] = answerIndex;
		},
		clearAll(state) {
			state.questionsArr = [];
			state.userAnswers = [];
			state.currentQuestionIndex = 0;
		},
	},
	actions: {
	},
	modules: {
	},
});
